import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'
import { ArrowForwardIos as ArrowForwardBase } from '@mui/icons-material'
import { Card as CardBase } from '@chilecompra/react-kit/components'

export const Root = styled('div')`
  width: 100%;
`

export const Content = styled(ContainerBase)`
  &.MuiContainer-root {
    padding: 32px 16px 48px;
  }

  ${props => props.theme.breakpoints.up('sm')} {
    &.MuiContainer-root {
      padding: 49px 38px;
    }
  }
`

export const GridContainer = styled(({ height, margin, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const JumboTitle = styled('h1')`
  color: ${props => props.theme.palette.brand.black1};
  background-color: ${props => props.theme.palette.brand.gray3};
  padding: 4px;
  max-width: 322px;
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: bold;
  font-size: 27px;
  line-height: 32px;
  margin: 8px 0 0;

  ${props => props.theme.breakpoints.up('sm')} {
    margin: 57px 0 0;
  }
`

export const JumboDescription = styled('p')`
  display: inline-block;
  color: ${props => props.theme.palette.brand.black1};
  background-color: ${props => props.theme.palette.brand.gray3};
  padding: 4px;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 19px;
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: bold;
  line-height: 32px;
  margin: 0;
  padding: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  padding: 0;
`

export const Card = styled(CardBase)`
  cursor: pointer;

  &.MuiPaper-root > div {
    height: 100%;
    padding: 5px 16px;
  }
`

export const Icon = styled(props => <img alt="" {...props} />)`
  margin: 0 16px 0 0;
`

export const Text = styled('span')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  max-width: 140px;
`

export const ArrowRight = styled(ArrowForwardBase)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black3};
    font-size: 12px;
    margin: 0 0 0 auto;
  }
`
